import PortraitFlip from "./PortraitFlip";
import { aboutPortraits } from "../config/portraits";
import React, { useState } from "react";
// eslint-disable-next-line no-unused-vars
import resumeFile from "../documents/resume.pdf";
import AboutModal from "./AboutModal";
// eslint-disable-next-line no-unused-vars
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Dynamic PDF generator - removed as not needed for View CV button

// Logos array - commented out as not currently used
// eslint-disable-next-line no-unused-vars
const skillLogos = [
  { src: "/assets/skills/wordpress.png", alt: "WordPress" },
  { src: "/assets/skills/woocommerce.png", alt: "WooCommerce" },
  { src: "/assets/skills/acf.png", alt: "ACF" },
  { src: "/assets/skills/shopify.png", alt: "Shopify" },
  { src: "/assets/skills/javascript.png", alt: "Liquid" },
  { src: "/assets/skills/whmcpanel.png", alt: "WHM/cPanel" },
  { src: "/assets/skills/javascript.png", alt: "JavaScript" },
  { src: "/assets/skills/htmlcss.png", alt: "HTML/CSS" },
  { src: "/assets/skills/reactjs.png", alt: "React JS" },
  { src: "/assets/skills/nextjs.png", alt: "Next JS" },
  { src: "/assets/skills/node.png", alt: "Node" },
];

// eslint-disable-next-line no-unused-vars
const sliderSettings = {
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 2000,
  infinite: true,
  arrows: false,
  pauseOnHover: false,
  cssEase: "linear",
  adaptiveHeight: false,
  variableWidth: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
};

// Unused component - commenting out to remove warning
// function SkillsSlider() {
//   return (
//     <div className="skills-slider">
//       <Slider {...sliderSettings}>
//         {skillLogos.map((logo) => (
//           <div key={logo.alt} style={{ textAlign: "center" }}>
//             <img
//               src={logo.src}
//               alt={logo.alt}
//               style={{ height: 60, margin: "0 auto" }}
//             />
//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// }

const AboutUs = ({ classicHeader, darkTheme }) => {
  const [showModal, setShowModal] = React.useState(false);

  const handleViewCV = () => {
    window.location.href = '/cv';
  };

  const longText = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nunc ut laoreet dictum, urna erat ultricies enim, nec facilisis massa enim nec sem. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Etiam euismod, justo eu convallis placerat, enim erat cursus enim, nec facilisis massa enim nec sem.`;
  return (
    <section
      id="about"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div data-reveal className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            About Me
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            Who I Am
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gy-5">
          {/* Profile Image start */}
          <div data-reveal className="col-lg-5 col-xl-4">
            <PortraitFlip images={aboutPortraits} />
          </div>
          {/* Profile Image end */}
          {/* About me content start */}
          <div data-reveal data-reveal-delay="0.12" className="col-lg-7 col-xl-8 text-center text-lg-start">
            <h2
              className={"text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")}
            >
              A little <span className="text-primary">about me.</span>
            </h2>
            <p className={darkTheme ? "text-white-50" : ""}>
              I’m <b>Facundo Criscuolo</b>, an independent{" "}
              <b>IT and Web Development Consultant</b> based in Argentina,
              specialized in WordPress, hosting infrastructure, and AI-driven
              workflow automation.
              <br />
              Over the past years, I’ve helped businesses, agencies, and
              organizations build, manage, and optimize their online platforms,
              always focusing on performance, usability, and long-term
              scalability.
              <br />
              My work combines hands-on technical expertise with AI-powered tools,
              covering every stage from architecture and implementation to
              optimization and long-term support, making technology more
              efficient, accessible, and truly useful for every project I work
              on.
              <br />
              {/* <a
                href="#"
                style={{ fontSize: "1rem" }}
                onClick={(e) => {
                  e.preventDefault();
                  setShowModal(true);
                }}
              >
                Full Story
              </a> */}
            </p>
            <AboutModal
              show={showModal}
              onClose={() => setShowModal(false)}
              content={longText}
            />
            
            {/* Personal Details and CV Download */}
            <div className="row mt-4 align-items-center">
              <div className="col-12 col-md-6">
                <ul
                  className={
                    "list-style-2 mb-3 mb-md-0 " +
                    (darkTheme ? "list-style-light text-light" : "")
                  }
                >
                  <li>
                    <span className="fw-600 me-2">Nationality:</span>
                    <img
                      src="https://flagcdn.com/w20/ar.png"
                      srcSet="https://flagcdn.com/w40/ar.png 2x"
                      width="20"
                      alt="Argentina"
                    />{" "}
                    <img
                      src="https://flagcdn.com/w20/it.png"
                      srcSet="https://flagcdn.com/w40/it.png 2x"
                      width="20"
                      alt="Italy"
                    />
                  </li>
                  <li className="border-0">
                    <span className="fw-600 me-2">Languages:</span>Spanish,
                    English, Italian
                  </li>
                </ul>
              </div>
              <div className="col-12 col-md-6 text-center text-md-end">
                <button
                  onClick={handleViewCV}
                  className="btn btn-primary rounded-pill"
                >
                  <i className="fas fa-eye me-2"></i>
                  View CV
                </button>
              </div>
            </div>
          </div>
          {/* About me content end */}
        </div>
        {/* projects rewards counting start */}
        <div
          className={
            "brands-grid separator-border mt-5 " +
            (darkTheme ? "separator-border-light" : "")
          }
        >
          <div className="row justify-content-center">
            <div className="col-4 col-md-4">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-10 text-md-12 mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  +16
                </h4>
                <p
                  className={
                    "mb-0 small " + (darkTheme ? "text-light" : "")
                  }
                >
                  years of experience
                </p>
              </div>
            </div>
            <div className="col-4 col-md-4">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-10 text-md-12 mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  +100
                </h4>
                <p
                  className={
                    "mb-0 small " + (darkTheme ? "text-light" : "")
                  }
                >
                  lauched websites
                </p>
              </div>
            </div>
            <div className="col-4 col-md-4">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-10 text-md-12 mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  +200
                </h4>
                <p
                  className={
                    "mb-0 small " + (darkTheme ? "text-light" : "")
                  }
                >
                  happy clients
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* projects rewards counting end */}
      </div>
    </section>
  );
};

export default AboutUs;
